import { Link } from "react-router-dom";
import { APP_NAME } from "@pms/shared";
import { fmtMoney, useBudget, useTasks, useWorkspace } from "../api";
import { ErrorBox, Loading } from "../components/State";

export default function Home() {
  const ws = useWorkspace();
  const budget = useBudget();
  const tasks = useTasks();

  if (ws.loading) return <Loading what="workspace" />;
  if (ws.error || !ws.data) return <ErrorBox error={ws.error ?? "no data"} what="workspace" />;

  const w = ws.data;
  const b = budget.data;
  const all = tasks.data?.tasks ?? [];
  const soon = all
    .filter((t) => t.status !== "done" && t.dueAt)
    .filter((t) => new Date(t.dueAt!) <= new Date(Date.now() + 21 * 864e5))
    .sort((a, z) => (a.dueAt! < z.dueAt! ? -1 : 1))
    .slice(0, 6);

  return (
    <>
      <div className="card">
        <span className="badge">iPhone · iPad · Web</span>
        <h2 style={{ marginTop: 12 }}>{w.name}</h2>
        <p>
          {APP_NAME} — skills triple, 4-level org pyramid, list/board/Gantt, runway budget and
          AI-ready <code>.txt</code> reports.
        </p>
        <div className="row" style={{ marginTop: 12 }}>
          <Link className="btn primary" to="/people">
            People
          </Link>
          <Link className="btn" to="/pyramid">
            Org pyramid
          </Link>
          <Link className="btn" to="/projects">
            Projects
          </Link>
          <Link className="btn" to="/reports">
            Reports
          </Link>
        </div>
      </div>

      <div className="grid-2">
        <div className="stat">
          <strong>{w.counts.people}</strong>
          <span>People</span>
        </div>
        <div className="stat">
          <strong>{w.counts.openTasks}</strong>
          <span>Open tasks of {w.counts.tasks}</span>
        </div>
        <div className="stat">
          <strong>{w.counts.projects}</strong>
          <span>Active projects</span>
        </div>
        <div className="stat">
          <strong>{w.counts.vacancies}</strong>
          <span>Open seats</span>
        </div>
      </div>

      {b && (
        <div className="card">
          <h2>Runway</h2>
          <div className="grid-2">
            <div className="stat">
              <strong className={b.runwayStatus === "critical" ? "over" : "ok"}>
                {b.runwayMonths === null ? "generative" : `${b.runwayMonths.toFixed(1)} mo`}
              </strong>
              <span>Runway — {b.runwayStatus}</span>
            </div>
            <div className="stat">
              <strong>{fmtMoney(b.closingCash, b.currency)}</strong>
              <span>Cash at {b.periodEnd}</span>
            </div>
            <div className="stat">
              <strong>{fmtMoney(Math.round(b.monthlyBurn), b.currency)}</strong>
              <span>Monthly net burn</span>
            </div>
            <div className="stat">
              <strong>{fmtMoney(b.actualRevenue, b.currency)}</strong>
              <span>Revenue this period</span>
            </div>
          </div>
          <div className="row" style={{ marginTop: 12 }}>
            <Link className="btn" to="/budget">
              Open budget
            </Link>
          </div>
        </div>
      )}

      <div className="card">
        <h2>Due in the next 3 weeks</h2>
        {soon.length === 0 ? (
          <p>Nothing due.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Due</th>
                <th>Task</th>
                <th>Project</th>
                <th>Owner</th>
              </tr>
            </thead>
            <tbody>
              {soon.map((t) => (
                <tr key={t.id}>
                  <td className="mono-inline">{t.dueAt}</td>
                  <td>
                    {t.isMilestone && <span className="badge">milestone</span>} {t.title}
                  </td>
                  <td>{t.projectName}</td>
                  <td>{t.assignees.find((a) => a.role === "responsible")?.name ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
